import React, { useEffect, useState } from "react";

import Box from '@mui/material/Box';

import warningIcon from "../img/warning-icon.svg"
import arrowHandMade from "../img/arrow-up-handmade.svg"

const HoneycombAlertPagedesk = () => {
  return (
    <div className="blurred-background" >

      <div className="job-inprogress-alert" >

        <div className="honeycomb-jip-alert">
          <img src={warningIcon} alt="Warning Icon" height="50px" style={{ marginRight: '1em' }} />
          <h3>
            Please complete your current job to claim a new one
          </h3>
        </div>

        <div style={{ marginBottom: '8em', marginRight: '2em' }}>
          <img src={arrowHandMade} alt="arrow up" height="128px" width="110px" />
        </div>

      </div>

    </div>

  )
}

const HoneycombAlertPageMobile = () => {
  return (
    <div className="blurred-background-mobile" >

      <div className="honeycomb-jip-alert-mobile">
        <img src={warningIcon} alt="Warning Icon" height="32px" style={{ marginBottom: '1em' }} />
        <h5>
          Please complete your current job to claim a new one
        </h5>
      </div>


    </div>
  )
}

export default function HoneycombAlertPage() {

  const [width, setWidth] = useState(window.innerWidth);

  const updateDimensions = () => {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  return (
    <Box className="honeycomb-alert-container" >
      {window.innerWidth > 1050 ? <HoneycombAlertPagedesk /> : <HoneycombAlertPageMobile />}
    </Box>

  )
}